import styled from 'styled-components'

export const Item = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  max-height: 32px;

  padding: 6px 0 6px 16px;

  cursor: pointer;
  flex: 1;

  background-color: ${({ selected }) => (selected ? 'var(--Background-Primary-faded, #edecfd)' : 'transparent')};

  &:hover {
    background-color: ${({ selected }) =>
      selected ? 'var(--Background-Primary-faded, #edecfd)' : 'var(--Background-Neutral, #dfe2ea66)'};
  }
`

export const Label = styled.div`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const List = styled.div`
  overflow: hidden;

  min-width: 100%;
  max-width: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;

  overflow-y: auto;
`

export const Error = styled.div`
  min-width: 100%;
  max-width: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;

  align-items: start;
  justify-content: start;

  padding-top: 16px;
  padding-left: 16px;

  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
